import { render, staticRenderFns } from "./DataLogCompareModal.vue?vue&type=template&id=2a04ad98&scoped=true"
import script from "./DataLogCompareModal.vue?vue&type=script&lang=js"
export * from "./DataLogCompareModal.vue?vue&type=script&lang=js"
import style0 from "./DataLogCompareModal.vue?vue&type=style&index=0&id=2a04ad98&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04ad98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a04ad98')) {
      api.createRecord('2a04ad98', component.options)
    } else {
      api.reload('2a04ad98', component.options)
    }
    module.hot.accept("./DataLogCompareModal.vue?vue&type=template&id=2a04ad98&scoped=true", function () {
      api.rerender('2a04ad98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DataLogCompareModal.vue"
export default component.exports